import { Injector } from '@angular/core';

import { IFilterConfigItem, ItemType } from '@firestitch/filter';

import { map } from 'rxjs/operators';

import { remove } from 'lodash-es';

import { nameValueImage } from '@app/common/helpers';
import { ProjectData, StatusData, TypeData, AttributeData } from '@app/core/data';


export class FilterConfigService {

  protected _filters: IFilterConfigItem[] = [];
  protected _selectedProjects: { name: string; value: number }[] = [];
  protected _selectedPlans: { name: string; value: number }[] = [];

  private _projectId: number;

  constructor(
    protected _injector: Injector,
  ) { }

  public get projectId(): number {
    return this._projectId;
  }

  public set projectId(projectId: number) {
    this._projectId = projectId;
  }

  public get selectedProjectIds(): number[] {
    return this._selectedProjects.map((project) => {
      return project.value;
    });
  }

  public get selectedPlanIds(): number[] {
    return this._selectedPlans.map((plan) => {
      return plan.value;
    });
  }

  public get filters(): IFilterConfigItem[] {
    return this._filters;
  }

  public getFilter(name: string): IFilterConfigItem {
    return this._filters.find((filter) => {
      return name === filter.name;
    });
  }

  public removeFilter(name: string): void {
    remove(this._filters, (filter) => {
      return name === filter.name;
    });
  }

  public createFilterProject(): IFilterConfigItem {
    return {
      name: 'projectId',
      type: ItemType.AutoCompleteChips,
      label: 'Project',
      hide: !!this.projectId,
      change: (item) => {
        this._selectedProjects = item.value;
      },
      values: (keyword) => {
        const projectData = this._injector.get(ProjectData);

        return projectData.gets({ keyword, order: 'name,asc' })
          .pipe(
            map((response) => nameValueImage(response, 'image.small')),
          );
      },
    };
  }

  public createFilterStatus(klass: string): IFilterConfigItem {
    return {
      name: 'statusId',
      type: ItemType.AutoCompleteChips,
      label: 'Status',
      chipColor: '#fff',
      chipBackground: 'color',
      values: (keyword) => {
        const statusData = this._injector.get(StatusData);

        return statusData.gets({ class: klass, keyword })
          .pipe(
            map((response) => {
              return response.map((item) => ({
                ...item,
                value: item.id,
              }));
            }),
          );
      },
    };
  }

  public createFilterTag(klass: string): IFilterConfigItem {
    return {
      name: 'tagAttributeIds',
      type: ItemType.AutoCompleteChips,
      label: 'Tag',
      chipColor: '#fff',
      chipBackground: 'color',
      values: (keyword) => {
        const attributeData = this._injector.get(AttributeData);

        return attributeData.gets({
          class: klass,
          keyword,
          projectId: this.projectId,
        })
          .pipe(
            map((response) => {
              return response.map((item) => ({
                name: item.name,
                value: item.id,
                color: item.backgroundColor,
              }));
            }),
          );
      },
    };
  }

  public createFilterType(klass: string): IFilterConfigItem {
    return {
      name: 'typeId',
      type: ItemType.AutoCompleteChips,
      label: 'Type',
      chipColor: '#fff',
      chipIcon: 'icon',
      chipBackground: 'color',
      values: (keyword) => {
        const typeData = this._injector.get(TypeData);

        return typeData.gets({ class: klass, keyword })
          .pipe(
            map((response) => {
              return response.map((item) => ({
                ...item,
                value: item.id,
              }));
            }),
          );
      },
    };
  }

  public createFilterKeyword(): IFilterConfigItem {
    return {
      name: 'keyword',
      type: ItemType.Keyword,
      label: 'Search',
    };
  }

}
